const childRoutes = prop => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    },
    {
        path: 'donation-management/kinds-donation',
        name: prop + '.donation_management.kinds_donation',
        meta: { auth: true },
        component: () => import('../pages/donation-management/kinds-donation/List.vue')
    },
    {
        path: 'donation-management/financial-donation',
        name: prop + '.donation_management.financial_donation',
        meta: { auth: true },
        component: () => import('../pages/donation-management/financial-donation/List.vue')
    },
    {
        path: 'donation-management/financial-donation-others',
        name: prop + '.donation_management.financial_donation',
        meta: { auth: true },
        component: () => import('../pages/donation-management/financial-donation-others/List.vue')
    },
    {
        path: 'donation-management/financial-donation-fdr',
        name: prop + '.donation_management.financial_donation',
        meta: { auth: true },
        component: () => import('../pages/donation-management/financial-donation-fdr/List.vue')
    },
    {
        path: 'monthly-budget',
        name: prop + '.monthly_budget',
        meta: { auth: true },
        component: () => import('../pages/monthly-budget/List.vue')
    },
    {
        path: 'payment-management/online-payment-list',
        name: prop + '.payment_management.online_payment_list',
        meta: { auth: true },
        component: () => import('../pages/payment-management/online-payment-list/List.vue')
    },
    {
        path: 'payment-management/payment-list',
        name: prop + '.payment_management.payment_list',
        meta: { auth: true },
        component: () => import('../pages/payment-management/payment-list/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/store-management',
        name: 'hospital_disability_service.store-management',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.store_management')
    }
]

export default routes
